/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Cache toggle request
 * @export
 * @interface SessionCacheToggleRequest
 */
export interface SessionCacheToggleRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SessionCacheToggleRequest
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the SessionCacheToggleRequest interface.
 */
export function instanceOfSessionCacheToggleRequest(value: object): value is SessionCacheToggleRequest {
    return true;
}

export function SessionCacheToggleRequestFromJSON(json: any): SessionCacheToggleRequest {
    return SessionCacheToggleRequestFromJSONTyped(json, false);
}

export function SessionCacheToggleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionCacheToggleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function SessionCacheToggleRequestToJSON(json: any): SessionCacheToggleRequest {
    return SessionCacheToggleRequestToJSONTyped(json, false);
}

export function SessionCacheToggleRequestToJSONTyped(value?: SessionCacheToggleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

